import { getCurrentLocation } from '../../../self-signup/components/google-maps/get-location';
import throttle from 'lodash/throttle';
import getFeatureFlags from '../../selectors/getFeatureFlags';
import get from 'lodash/get';
import getGlobalState from '../../selectors/getGlobalState';

let latitude = null;
let longitude = null;
const fetchLocation = async () => {
  return new Promise((resolve, reject) => {
    getCurrentLocation()
      .then(position => {
        ({ latitude, longitude } = position);
        resolve({ latitude, longitude });
      })
      .catch(() => {
        resolve({ latitude, longitude });
      });
  });
};

let throttleDelay = 5 * 60 * 1000;
const throttledFetchLocation = throttle(fetchLocation, throttleDelay);

const updateGAEventLocation = async () => {
  const globalState = getGlobalState();
  throttleDelay = get(getFeatureFlags(globalState), 'location_data_config.throttleDelay', 5 * 60 * 1000);

  return await throttledFetchLocation();
};

export default updateGAEventLocation;
